import type { ApolloError } from '@apollo/client'
import { gql } from '@apollo/client'
import { useMutation } from '@ztechapps/common.hook'
import type { ExportProductWithSpecArgs, ImportExportProductSpec } from '@ztechapps/common.contract'
import { jsonTryParse } from '@ztechapps/common.utils'

export const exportProductWithSpecQuery = gql`
  mutation exportProductWithSpec($input: ExportProductWithSpecArgs) {
    exportProductWithSpec(input: $input)
  }
`

export type UseImportSpecificationsResult = {
  exportProductWithSpec: (productId: string) => Promise<ImportExportProductSpec[]>
  loading: boolean
  error: ApolloError
}

export const useExportSpecifications = (): UseImportSpecificationsResult => {
  const [exportProductWithSpecMutation, , { loading, error }] = useMutation<
    { exportProductWithSpec: string },
    ExportProductWithSpecArgs
  >({
    query: exportProductWithSpecQuery,
  })

  const exportProductWithSpec = async (productId: string) => {
    const result = await exportProductWithSpecMutation({
      input: {
        productId,
      },
    })

    return jsonTryParse(result?.data?.exportProductWithSpec) as ImportExportProductSpec[]
  }

  return {
    exportProductWithSpec,
    loading,
    error,
  }
}
